<mat-card appearance="raised">
  <mat-card-header>
    <mat-card-title>Welcome call</mat-card-title>
  </mat-card-header>
  <mat-card-content class="no-bottom-padding">
    <ifc-horizontal-list [items]="listItems">
      <ng-template horizontalListCustomTemplate="ringDNALinkValue">
        <button class="mat-icon-button-sm"
                mat-icon-button
                *ngIf="welcomeCallData?.ringDnaLink"
                aria-label="Copy"
                (click)="copy(welcomeCallData?.ringDnaLink)">
          <mat-icon>content_copy</mat-icon>
        </button>
      </ng-template>
    </ifc-horizontal-list>
  </mat-card-content>
</mat-card>
